/**
 * Stamp Group shared block scripts
 * This file gets shared between the
 * theme and editor.
 */
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';


gsap.registerPlugin(ScrollTrigger);

gsap.utils.toArray('.stamp-group--has-stamp').forEach((group) => {
	const type = group.dataset.stamp;
	const stamp = group.querySelector(`.stamp-group__image--${type}`);
	const ani = 'circle' === type ? {
		y: '-25%', opacity: 0, rotate: -25,
	} : {
		opacity: 0, scale: 0.8, rotate: 10,
	}

	gsap.from(stamp, {
		...ani,
		scrollTrigger: {
				trigger: group,
				ease: 'linear',
				start: '10% bottom',
				end: 'bottom top',
				scrub: 0.9,
				toggleActions: 'play reset play reset',
				// /*DEBUG*/markers: true, id: 'stamp',
		}
	});

});